import * as React from 'react';

function SvgHelp(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 16.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0 1.5a8 8 0 100-16 8 8 0 000 16z"
        fill={props.color}
      />
      <path
        d="M9.05 11.277v-.416c0-.36.077-.672.23-.938.154-.265.434-.548.842-.848.393-.28.652-.509.775-.685a.982.982 0 00.191-.59c0-.243-.09-.428-.27-.555-.18-.127-.43-.191-.752-.191-.561 0-1.202.183-1.92.55l-.612-1.23a5.35 5.35 0 012.656-.701c.77 0 1.383.185 1.836.556.457.37.685.864.685 1.482 0 .412-.094.767-.28 1.067-.188.3-.544.636-1.068 1.01-.36.266-.587.469-.685.607-.093.139-.14.32-.14.545v.337H9.05zm-.18 1.92c0-.314.084-.552.253-.713.168-.161.413-.242.735-.242.311 0 .55.083.72.247.171.165.257.401.257.708 0 .296-.086.53-.258.702-.172.168-.412.253-.719.253-.314 0-.557-.083-.73-.247-.172-.169-.258-.405-.258-.708z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgHelp;
